import React, { Component, Fragment } from 'react';
import InputRangePricing from './InputRange';
import classnames from 'classnames';
import buildPrice from 'helpers/buildPrice';
import CheckedSvg from 'images/svg_js/CheckedSvg';

const PRO_PLAN = [
  {
    text: 'Single domain',
    id: '1',
  },
  {
    text: 'Unlimited links',
    id: '2',
  },
  {
    text: 'Advanced customization',
    id: '3',
  },
  {
    text: 'Custom shortcode',
    id: '4',
  },
  {
    text: 'White label branding',
    id: '5',
  },
  {
    text: 'Advanced analytics',
    id: '6',
  },
  {
    text: 'Create image links',
    id: '7',
  },
];

const YEAR_PLAN = [
  {
    text: 'Unlimited links',
    id: '1',
  },
  {
    text: 'Advanced customization',
    id: '2',
  },
  {
    text: 'Custom shortcode',
    id: '3',
  },
  {
    text: 'White label branding',
    id: '4',
  },
  {
    text: 'Advanced analytics',
    id: '5',
  },
  {
    text: 'Create image links',
    id: '6',
  },
  {
    text: 'Priority support',
    id: '7',
  },
];

const BasicPlan = ({ text }) => {
  return (
    <li className="pricing-itm__text">
      <div className="pricing-itm__text-icon">
        <CheckedSvg />
      </div>
      {text}
    </li>
  );
};

const PricingItm = ({
  title,
  price,
  priceDuration,
  plan,
  sale,
  btnText,
  customClass,
  rangeInputVal,
  rangeInputValue,
  handleChangeRange,
  priceValue,
  rangeValue,
  landing,
  period,
  youWillSave,
  onClick,
}) => {
  let percentage;
  if (rangeInputValue === 1) {
    percentage = 25;
  } else if (rangeInputValue === 2) {
    percentage = 50;
  } else if (rangeInputValue => 3) {
    percentage = 75;
  }
  return (
    <div
      onClick={onClick}
      className={customClass ? 'pricing-itm ' + customClass : 'pricing-itm'}>
      <div className="pricing-itm__inner">
        <div className="pricing-itm__top">
          <h4
            className={classnames('pricing-itm__title', {
              blue: period === 'monthly',
            })}>
            {title}
          </h4>
          {rangeValue && (
            <div className="pricing-itm-range">
              <span className="std-text small">Select domain quantity</span>
              <InputRangePricing
                rangeInputValue={rangeInputValue}
                handleChangeRange={handleChangeRange}
                landing={landing}
              />
            </div>
          )}
          {!rangeValue && <div className="pricing-itm-range p-t-59" />}
        </div>
        <div className="pricing-itm__value">
          $ {price}
          {priceDuration && <sub>{priceDuration}</sub>}
          {priceValue && (
            <div className="pricing-itm__value-price">{priceValue}</div>
          )}
          {youWillSave && (
            <div className="std-text blue p-t-10">
              You'll save up to {percentage}%
            </div>
          )}
        </div>
        <div className="pricing-itm__descr">
          <ul className="pricing-itm__list">
            {plan.map(itm => (
              <BasicPlan text={itm.text} key={itm.id} />
            ))}
          </ul>
        </div>
        <div className="pricing-itm__btn">
          <a
            href={
              rangeValue
                ? `/sign_up?accounts=${rangeInputValue}&plan=${period}`
                : `/sign_up?plan=${period}`
            }
            className="btn btn-blue outline btn-pricing full-width">
            {btnText}
          </a>
        </div>
      </div>
    </div>
  );
};

const PricingItmYear = ({
  title,
  price,
  priceDuration,
  plan,
  sale,
  perMonth,
  perMonthDuration,
  customClass,
  period,
}) => {
  return (
    <div className={'pricing-itm ' + customClass}>
      <div className="pricing-itm__sale_banner">
        <h4
          className={classnames('pricing-itm__title', {
            white: period === 'annual',
          })}>
          {title}
        </h4>
        <div
          className={
            'pricing-itm__value sale_price_bottom ' +
            (title === 'Pro Annual' && 'white-important')
          }>
          <sup>$</sup>
          {price}
          <sub>{priceDuration}</sub>
        </div>
        <div className="pricing-itm__value sale_price">
          <sub>{perMonthDuration}</sub>
          {'  '}
          {perMonth}%
        </div>
      </div>
      <div className="pricing-itm__inner">
        <div className="pricing-itm__descr">
          <ul className="pricing-itm__list">
            {plan.map(itm => (
              <BasicPlan text={itm.text} key={itm.id} />
            ))}
          </ul>
        </div>
        <div className="pricing-itm__btn">
          <a href="/sign_up" className="btn btn-blue btn-pricing">
            Sign up
          </a>
        </div>
      </div>
    </div>
  );
};

class PricingPlans extends Component {
  state = {
    isChecked: true,
    isCheckedPackage: false,
    rangeInputVal: 1,
    period: 'annually',
  };

  toggleChange = () => {
    const { isChecked } = this.state;
    this.setState({ isChecked: !isChecked });
    if (isChecked) {
      this.setState({
        period: 'monthly',
      });
    } else {
      this.setState({
        period: 'annually',
      });
    }
  };

  handleChangeRange = val => {
    this.setState({
      rangeInputVal: val,
    });
  };

  handleCheckedPackage = () => {
    this.setState(({ isCheckedPackage }) => {
      isCheckedPackage: !isCheckedPackage;
    });
  };

  render() {
    const { isChecked, isCheckedPackage, rangeInputVal, period } = this.state;
    let domainPrice = (
      buildPrice(rangeInputVal, isChecked ? 'annually' : 'monthly') /
      rangeInputVal
    ).toFixed(2);
    return (
      <Fragment>
        <div className="pricing" id="pricing_plans">
          <div className="h2-title big center">Pricing & Plans</div>
          <div className="pricing-switch">
            <div
              className={classnames([
                'pricing-switch__text',
                { active: !isChecked },
              ])}>
              Billed Monthly
            </div>
            <div className="pricing-switch__center">
              <div className="checkbox-switch">
                <input
                  name="chooseAplan"
                  type="checkbox"
                  checked={isChecked}
                  onChange={this.toggleChange}
                  className="checkbox-switch__input"
                  id="choose-a-plan"
                />
                <label
                  htmlFor="choose-a-plan"
                  className="checkbox-switch__label"
                />
              </div>
            </div>
            <div
              className={classnames([
                'pricing-switch__text',
                { active: isChecked },
              ])}>
              Billed Yearly
              <div className="pricing-switch__save green">
                Save up to <strong>20%</strong>
              </div>
            </div>
          </div>
          <div className="pricing__content">
            {/*<PricingItm title="Basic" price="0" plan={BASIC_PLAN} />*/}
            <PricingItm
              title="Pro"
              price={isChecked ? '87.00' : '9.00'}
              onClick={() => this.handleCheckedPackage()}
              priceDuration={`${isChecked ? '/Year' : '/Month'}`}
              plan={PRO_PLAN}
              customClass={classnames([
                'pro-plan',
                { active: !isCheckedPackage },
              ])}
              period={period}
              btnText="Start as Pro"
            />
            <PricingItm
              title="Multi Pro"
              price={domainPrice}
              onClick={() => this.handleCheckedPackage()}
              priceDuration={`${isChecked ? '/Year' : '/Month'} /per Domain`}
              plan={YEAR_PLAN}
              rangeValue={true}
              rangeInputValue={rangeInputVal}
              youWillSave
              handleChangeRange={this.handleChangeRange}
              customClass={classnames([
                'pro-package',
                { active: isCheckedPackage },
              ])}
              period={period}
              btnText="Start with a Pro package"
              landing
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PricingPlans;



// WEBPACK FOOTER //
// ./src/components/PricingPlans/PricingPlans.js